<template>
  <div class="text-center" v-if="canShowModal">
    <v-dialog
      v-model="canShowModal"
      max-width="750"
			persistent
      scrollable
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <div class="d-flex flex-row align-center justify-space-between">
							<div class="d-flex flex-row align-center justify-start">
								<v-icon color="warning" class="mr-2">mdi-information</v-icon>
								<p class="mb-0 font-weight-bold text-primary body-1">Confirmación Cliente Empresa</p>
							</div>
							<div>
								<v-menu offset-y>
									<template v-slot:activator="{ on: menuOn, attrs: menuAttrs }">
										<v-tooltip bottom>
											<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
												<v-btn
													depressed
													color="#959595"
													dark
													icon
													class="mr-2"
													v-bind="{ ...tooltipAttrs, ...menuAttrs }"
													v-on="{ ...tooltipOn, ...menuOn }"
												>
													<v-icon>mdi-clipboard-text-clock-outline</v-icon>
												</v-btn>
											</template>
											<span>Historial de cambios en solicitud</span>
										</v-tooltip>
									</template>
									<v-list dense class="py-0 white">
										<v-list-item dense class="mb-0" style="min-height: 25px; background: #959595;">
											<div>
												<p class="caption mb-0 font-weight-bold white--text">Historial de cambios en solicitud</p>
											</div>
										</v-list-item>
										<v-list-item dense class="my-0 py-0" style="min-height: 25px;">
											<div class="d-flex justify-space-between align-center flex-grow-1">
												<p class="caption mb-0 text--disabled" style="width: 90px;">Estado</p>
												<p class="caption mb-0 text--disabled" style="width: 90px;">Fecha</p>
												<p class="caption mb-0 text--disabled text-end" style="width: 250px;">Responsable</p>
											</div>
										</v-list-item>
										<v-divider></v-divider>
										<v-list-item-group color="#524D4D" style="max-height: 350px;overflow-y:scroll;">
											<v-list-item
												v-for="(acc, index) in client.accreditation?.history"
												:key="'ctstatus-'+index"
												dense
												style="min-width: 350px;"
												class="white"
											>
												<v-list-item-title dense>
													<div class="d-flex justify-space-between align-center item-background-hover">
														<div class="d-flex align-center justify-space-between caption" style="width: 90px;">
															<v-chip
																:color="accreditationStatusColor(acc)"
																label
																outlined
																small
																class="px-1"
															>
																<b>{{ accreditationStatus(acc) }}</b>
															</v-chip>
														</div>
														<div class="d-flex justify-end caption" style="width: 90px;">
															<p class="mb-0 caption text-end">{{acc.created_at | toDateTime}}</p>
														</div>
														<div class="d-flex justify-end caption" style="width: 250px;">
															<p class="mb-0 caption text-end">{{ acc.company_user?.profile?.name + ' ' + acc.company_user?.profile?.lastname + ' ' + acc.company_user?.profile?.second_lastname }}</p>
														</div>
													</div>
												</v-list-item-title>
											</v-list-item>
										</v-list-item-group>
									</v-list>
								</v-menu>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											small
											color="#959595"
											@click="closeModal()"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon dark>mdi-close</v-icon>
										</v-btn>
									</template>
									<span>Cerrar</span>
								</v-tooltip>
							</div>
						</div>
						<div class="my-4">
							<div v-if="status === 1">
								<div class="mb-0">El usuario <b>{{ clientName }}</b> ha solicitado la aprobación para trabajar en la plataforma como empresa.</div>
								<div class="mb-2">Por favor revisa sus datos y aprueba o rechaza esta soclitud.</div>
							</div>
							<div v-else-if="status === 0">
								<div>El usuario <b>{{ clientName }}</b> ha solicitado la aprobación para trabajar en la plataforma como empresa.</div>
								<v-divider class="my-2"></v-divider>
								<div><b>Esta solicitud ha sido rechazada previamente</b> con el siguiente mensaje:</div>
								<v-chip
									color="error"
									label
									outlined
									v-if="client.accreditation?.last_history?.detail"
								>
									<v-icon left>
										mdi-close-octagon-outline
									</v-icon>
									<b>Observación: {{ client.accreditation?.last_history?.detail }}</b>
								</v-chip>
								<v-divider class="my-2"></v-divider>
								<div class="mb-2">Por favor revisa sus datos y aprueba o rechaza esta soclitud.</div>
							</div>
							<div v-else-if="status === 2">
								<div class="mb-1">El usuario <b>{{ clientName }}</b> ha solicitado la aprobación para trabajar en la plataforma como empresa.</div>
								<v-divider class="my-2"></v-divider>
								<div><b>Esta solicitud ya ha sido aprobada.</b></div>
								<v-chip
									color="success"
									label
									outlined
									v-if="client.accreditation?.last_history?.detail"
								>
									<v-icon left>
										mdi-check
									</v-icon>
									<b>Observación: {{ client.accreditation?.last_history?.detail }}</b>
								</v-chip>

								<div class="mb-2">Para modificar esta aprobación puedes rechazar esta solicitud.</div>
							</div>

							<div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Empresa</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.name}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rut | formatRut}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.email}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.phone}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.address}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Comuna</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.city?.name}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_name}} {{client.company_profile.rep_first_lname}} {{client.company_profile.rep_second_lastname}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.email}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_rut | formatRut}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_address}}</b></div>
								<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Comuna R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{client.company_profile.rep_city?.name}}</b></div>
								<v-divider class="my-2"></v-divider>
								<p class="mb-0 caption font-weight-bold">Documentos para Acreditación de la Información</p>
								<v-row no-gutters>
									<v-col
										cols="12"
										sm="6"
										v-for="(file) in client.accreditation_documents"
										:key="file.id"
									>
										<div class="pa-2">
											<v-btn
												color="#524D4D"
												dark
												outlined
												block
												x-small
												@click="toDocumentUrl(file)"
											>
												<v-icon small>mdi-download</v-icon>
												<p class="mb-0 ml-2 caption">
													{{ getFileAccreditationName(file) }}
												</p>
											</v-btn>
									</div>
									</v-col>
								</v-row>
							</div>
						</div>
          </div>
        </v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<div style="width: 100%;">
							<p class="mb-2 font-weight-bold caption">Confirmación</p>
							<v-textarea
								v-model="detail"
								label="Agrega un mensaje o detalle para el usuario"
								counter="255"
								outlined
								auto-grow
								color="grey"
								rows="3"
							></v-textarea>
							<div class="d-flex flex-row justify-space-between">
								<v-btn
									depressed
									dark
									outlined
									color="#959595"
									class="mr-3"
									@click="closeModal()"
								>
									<v-icon dark>mdi-close</v-icon>
									<p class="ml-2 mb-0">Cancelar</p>
								</v-btn>
								<div class="d-flex align-center justify-end">
									<v-btn
										depressed
										dark
										color="#FF120B"
										class="mr-2"
										v-if="status !== 0"
										@click="changeAccreditationStatus(false)"
									>
										<v-icon dark>mdi-close-octagon-outline</v-icon>
										<p class="ml-2 mb-0">Rechazar </p>
									</v-btn>
									<v-btn
										depressed
										dark
										color="success"
										v-if="status != 2"
										@click="changeAccreditationStatus(true)"
									>
										<v-icon dark>mdi-check</v-icon>
										<p class="ml-2 mb-0">Aprobar</p>
									</v-btn>
								</div>
							</div>
						</div>

					</v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { setCompanyAccreditationUserStatus } from '@/helpers/api/user'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

export default {
  name: 'ClientCompanyAprovalConfirmationModal',
	props: {
		modalData: {
			type: Object,
			default: null
		}
	},
  data: () => ({
		indexModal: + new Date(),
		detail: null,
  }),
  computed: {
		client(){
			return this.$store.state.users.clientCompanyAprovalModal?.client
		},
		status(){
			return this.client.accreditation?.last_history?.status
		},
		canShowModal(){
			return this.$store.state.users.clientCompanyAprovalModal?.status
		},
		indexModalIndex(){
			const ordered = [...this.$store.state.general.openModalOrders].sort((a, b) => a - b)
			return ordered.indexOf(this.indexModal) + 10
		},
		clientName(){
			return this.client?.profile.name + ' ' + this.client?.profile.lastname + ' ' +  this.client?.profile.second_lastname
		}
	},
	watch: {
	},
  mounted(){
  },
  methods: {
		closeModal(){
			this.$store.commit('users/setClientCompanyAprovalModal', null)
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		async changeAccreditationStatus(newStatus){
			if(!newStatus && !this.detail){
				const messageData = {
					message: 'Al rechazar debes indicar el motivo del rechazo.',
					title: 'Campos Requeridos',
					type: 'error',
					icon: 'mdi-alert-circle-outline',
					color: '#FF120B',
				}
				this.setMessage(messageData)
				return
			}
			await setCompanyAccreditationUserStatus({
				user_id: this.client.id,
				status: newStatus,
				detail: this.detail
			})
			this.$store.dispatch('users/getCompanyClient', this.client.id)
			eventBus.$emit('reloadInformation')
			this.closeModal()
		},
		toDocumentUrl(file){
			window.open(file.file?.file_link, '_blank')
		},
		getFileAccreditationName(file){
			switch (file.type) {
				case 1:
					return 'Comprobante Dirección Usuario'
				case 2:
					return 'Certificado de Vigencia'
				case 3:
					return 'Estatuto Actualizado'
				case 4:
					return 'Escritura Constitución de Sociedad'
				case 5:
					return 'Comprobante Dirección RL'
			
				default:
					break;
			}
		},
		accreditationStatus(item){
			if(item.status === 2){
				return 'Aprobado'
			}
			else if(item.status === 0){
				return 'Rechazado'
			}
			return 'Solicitado'
		},
		accreditationStatusColor(item){
			if(item.status === 2){
				return 'success'
			}
			else if(item.status === 0){
				return 'error'
			}
			return '#959595'
		},
  }
};
</script>

<style scoped>
	.profile-avatar{
		cursor: pointer;
	}
  .info-container{
    color: #606060;
  }
  .text-primary{
    color: #524D4D;
  }
  .info-icon{
    background-color: #524D4D;
    border-radius: 25px;
    padding: 3px;
    width: 35px;
    height: 35px;
  }
  .info-icon.small-icon{
    width: 25px;
    height: 25px;
  }
  .info-img{
    width: 100%;
    max-height: 50px;
    object-fit: contain;
  }
  .adjuntos-container{
    background-color: #EFEFEF;
    max-height: 95px;
    overflow-y: scroll;
  }
  .interaction-container{
    width: 100%;
    background-color: #E5E9F2;
    border-radius: 5px;
    position: relative;
    padding: 12px;
  }
  .user-avatar.small{
    width: 25px;
    height: 25px;
  }
  .light-blue-text{color: #959595;}
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
  }
  .interaction-container.left .icon-arrow{
    right: -46px;
  }
  /deep/ .custom-input-numbers .v-input__slot{padding:0!important;}
  /deep/ .custom-input-numbers .v-input__prepend-inner,
  /deep/ .custom-input-numbers .v-input__append-inner,
  /deep/ .custom-text-input .v-input__append-inner{margin-top:0!important;}
  /deep/ .custom-input-numbers input {text-align: center }
</style>